/*!

=========================================================
* Paper Kit React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { useRecoilValue } from "recoil";
import { websiteDataState } from "helpers/recoil";

import ReactMarkdown from "react-markdown"

function SectionWieZijnWe() {
    const websiteData = useRecoilValue(websiteDataState)

    return (
        <>
            <div className="section" style={{ 
                padding: "80px 0",
                background: "linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)"
            }}>
                <Container>
                    <Row>
                        <Col className="ms-auto me-auto text-center" md="10" lg="8">
                            <h2 className="title" style={{ 
                                fontSize: "36px", 
                                fontWeight: "700",
                                color: "#2d3748",
                                marginBottom: "32px",
                                letterSpacing: "-0.5px",
                                lineHeight: "1.2"
                            }}>{websiteData?.snippetsDictionary?.['section-header-wiezijnwe']?.text }</h2>
                            <div style={{ 
                                fontSize: "16px", 
                                lineHeight: "1.7", 
                                color: "#4a5568",
                                textAlign: "left"
                            }}>
                                <ReactMarkdown>
                                    {websiteData?.snippetsDictionary?.['section-body-wiezijnwe']?.markup.markdown }
                                </ReactMarkdown>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default SectionWieZijnWe;
